import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';

const useLogEvent = () => {
  return useMutation({
    mutationFn: async (data: Types.IMutation.LogEvent) => {
      const response = await Api.LogEvent(data.attemptId, {
        type: data.type,
        payload: data.payload,
      });
      return response.data;
    },
    // Silently log events without notifications
    onError: (error: any) => {
      console.error('Failed to log event:', error?.response?.data?.message || error.message);
    },
  });
};

export default useLogEvent;
